/* app/js/src/components/common/soundBar/soundBar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  background-color: #232f3a;
  height: 15px;
  display: block;
  width: 100%;
  padding: 0 2px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
:host > button {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  background: none;
  border: none;
  padding: 0;
  margin: 1px 2px 0 0;
}
:host > button svg path {
  fill: #364b5e;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host > button:hover svg path {
  fill: rgba(64, 193, 254, 0.36);
}
:host > button.sound-on svg path {
  fill: #40c1fe;
}
:host > button:focus {
  outline: none;
}
.sound-indicator-wrapper {
  height: 10px;
  position: relative;
  overflow: hidden;
  margin-right: 34px;
  -webkit-flex: 10 0 0;
  -ms-flex: 10 0 0;
  flex: 10 0 0;
}
.sound-indicator-wrapper > i {
  -webkit-transition: width 0.1s ease;
  transition: width 0.1s ease;
  position: absolute;
  top: 1px;
  left: 0;
  bottom: 0;
  width: 50%;
  background-color: #40c1fe;
}
.sound-indicator-wrapper > ul {
  display: none;
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: 10px;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
.sound-indicator-wrapper > ul li {
  width: 1px;
  min-width: 1px;
  max-width: 1px;
  background-color: transparent;
  margin-right: 1px;
  position: relative;
}
.sound-indicator-wrapper > ul li:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background-color: #232f3a;
}
.sound-indicator-wrapper > ul li:last-child {
  margin-right: 0;
}
/*# sourceMappingURL=soundBar.component.css.map */
